export const NEW_COLUMN_ID = 'new-column';
